import { render } from "./Tiers.vue?vue&type=template&id=0196efb2"
import script from "./Tiers.vue?vue&type=script&lang=js"
export * from "./Tiers.vue?vue&type=script&lang=js"

import "./Tiers.vue?vue&type=style&index=0&id=0196efb2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__